var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('el-header',[_c('topbar')],1),_vm._v(" "),_c('el-container',{staticStyle:{"height":"calc(100vh - 60px)","width":"100%"}},[_c('el-aside',{attrs:{"width":"240px"}},[_c('left')],1),_vm._v(" "),_c('el-main',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21c90782","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/layout.vue
// module id = null
// module chunks = 